import { render, staticRenderFns } from "./NoticePhonePreview.vue?vue&type=template&id=565e514e&scoped=true"
import script from "./NoticePhonePreview.vue?vue&type=script&lang=js"
export * from "./NoticePhonePreview.vue?vue&type=script&lang=js"
import style0 from "./NoticePhonePreview.vue?vue&type=style&index=0&id=565e514e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e514e",
  null
  
)

export default component.exports